/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";
import axios from "axios";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Link from "next/link";
import SectionRenderer from "../../components/SectionRenderer";

interface Project {
  title: string;
  slug: string;
  summary?: string;
  content?: string;
  coverImageUrl?: string;
  tags?: string[];
  sections?: Section[];
  createdAt: Date;
  updatedAt: Date;
}

type SectionType = "hero" | "text" | "text-left" | "list" | "iframe";
interface Section {
  type: SectionType;
  data: any;
}

export default function ProjectPage() {
  const router = useRouter();
  const { slug } = router.query;
  const [project, setProject] = useState<Project | null>(null);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug || typeof slug !== "string") return;
    setLoading(true);
    axios
      .get(`/api/projects/${slug}`)
      .then((res) => {
        setProject(res.data);
        console.log("Project data:", res.data);
      })
      .catch(() => setError("Failed to load project"))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <>
      {/* Sticky back button to root */}
      <div
        style={{
          position: "fixed",
          top: 16,
          left: 16,
          zIndex: 2000,
        }}
      >
        <Link
          href="/projects"
          className="btn btn-primary"
          style={{
            borderRadius: 999,
            boxShadow: "0 6px 20px rgba(91, 33, 182, 0.25)",
            paddingInline: 16,
            paddingBlock: 8,
          }}
        >
          ← Projects
        </Link>
      </div>
      {/* <NavBar /> */}
      <div className="container">
        {loading && <p>Loading...</p>}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {!loading && !error && project && (
          <div className="mb-5 container d-flex flex-column justify-content-center align-items-center">
            {/* <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{
                background: `linear-gradient(rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)), url(${project.coverImageUrl})`,
                width: "100%",
                height: 300,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: 10,
                marginBottom: 20,
              }}
            >
              <h1 className="text-white">{project.title}</h1>
            </div> */}
            {/* {project.content && project.content.length > 0 ? (
              <>
                <p>{project.content}</p>
              </>
            ) : (
              <div className="card bg-glassy">
                {project.coverImageUrl && (
                  <img
                    src={project.coverImageUrl}
                    alt={project.title}
                    className="card-img-top"
                    style={{ objectFit: "cover", maxHeight: 360 }}
                  />
                )}
                <div className="card-body">
                  <h1 className="card-title">{project.title}</h1>
                  {project.tags && project.tags.length > 0 && (
                    <p className="mb-2">
                      {project.tags.map((t) => (
                        <span key={t} className="badge bg-secondary me-1">
                          {t}
                        </span>
                      ))}
                    </p>
                  )}
                  {project.summary && (
                    <p className="lead" style={{ whiteSpace: "pre-wrap" }}>
                      {project.summary}
                    </p>
                  )}
                  {project.content && (
                    <div style={{ whiteSpace: "pre-wrap" }}>
                      {project.content}
                    </div>
                  )}
                </div>
              </div>
            )} */}
            {project.sections && project.sections.length > 0 && (
              <div className="w-100">
                {project.sections.map((section, index) => (
                  <SectionRenderer key={index} section={section} />
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
